import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import ProjectPlaceholder from '../../ProjectPlaceholder';
import { fetchReportFromProject } from '../../../../../actions';
import { parseReport } from '../projectSummary/reportparser';

class ProjectSummary extends React.Component {

    componentDidMount() {
        this.props.fetchReportFromProject(this.props.project.id);
    }

    renderTable(reportLines) {

        return reportLines.map((line) => {
            return (
                <tr style={{ whiteSpace: 'nowrap' }}>
                    <td>
                        {/* FEATURE */}
                        {line.feature}
                    </td>
                    <td>
                        {/* PARAMETER */}
                        {line.parameter}
                    </td>
                    <td className="td-value-project-summary">
                        {/* VALUE */}
                        {line.value}
                    </td>
                    <td style={{ maxWidth: '100%', textAlign: 'left' }}>
                        {/* UNIT */}
                        {line.unit}
                    </td>
                </tr>
            );
        });
    }

    render() {

        if (!this.props.report) {
            return (<ProjectPlaceholder />);
            //return null;
        }

        const reportLines = [];
        parseReport(this.props.report, (feature, parameter, value, unit) => {
            reportLines.push({feature: feature, parameter: parameter, value: value, unit: unit});
        });

        return (
            <Table responsive striped bordered hover size="sm" style={{ marginBottom: '0' }}>
                <thead style={{ textAlign: 'center' }}>
                    <tr>
                        <th>Feature</th>
                        <th>Parameter</th>
                        <th style={{ maxWidth: '100vh' }}>Value</th>
                        <th style={{ maxWidth: '100%', width: '100%', textAlign: 'left' }}>Unit</th>
                    </tr>
                </thead>
                <tbody style={{ textAlign: 'center' }}>
                    {this.renderTable(reportLines)}
                </tbody>
            </Table>
        );
    };
};

const mapStateToProps = (state, ownProps) => {
    return {
        report: state.project.report,
    };
};

const mapDispatchToProps = {
    fetchReportFromProject,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectSummary);
